import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Shield, Star, Phone } from "lucide-react";

export const HERO_IMG = "https://images.pexels.com/photos/8146213/pexels-photo-8146213.jpeg?auto=compress&cs=tinysrgb&w=1400";

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 grain opacity-50 pointer-events-none" aria-hidden />
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-20 md:pt-24 md:pb-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <div className="eyebrow mb-5">Indoor Air Quality · MD · DC · VA</div>
          <h1 className="font-heading font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-ink leading-[1.02]">
            Breathe like the<br />
            <span className="text-forest">first day of spring.</span>
          </h1>
          <p className="mt-7 text-lg text-muted2 max-w-xl leading-relaxed">
            Meticulous air duct & dryer vent cleaning for homes and businesses across Maryland,
            Washington DC, and Virginia. Transparent flat-rate pricing. Photo proof every job.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <Link to="/book" className="btn-primary text-base" data-testid="hero-book-cta">
              Book Now <ArrowRight size={16} />
            </Link>
            <Link to="/packages" className="btn-ghost text-base" data-testid="hero-packages-cta">
              See Packages
            </Link>
            <a href="tel:+18003737324" className="hidden sm:inline-flex items-center gap-2 text-sm text-ink/70 hover:text-forest pl-2">
              <span className="inline-flex w-9 h-9 rounded-full bg-forest/10 items-center justify-center pulse-ring text-forest">
                <Phone size={14} />
              </span>
              1-800-FRESH-AIR
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-xs uppercase tracking-[0.18em] text-muted2">
            <span className="flex items-center gap-2"><Shield size={14} className="text-forest" /> Licensed & insured</span>
            <span className="flex items-center gap-2"><Star size={14} className="text-clay" /> 4.9 / 5 · 1.2k reviews</span>
            <span className="flex items-center gap-2"><CheckCircle2 size={14} className="text-forest" /> NADCA aligned</span>
          </div>
        </div>

        <div className="lg:col-span-5 relative animate-fade-in">
          <div className="relative rounded-3xl overflow-hidden card-surface hover-lift">
            <img
              src={HERO_IMG}
              alt="A sunlit modern living room with clean air"
              className="w-full h-[460px] object-cover"
              loading="eager"
            />
            <div className="absolute -bottom-5 -left-5 bg-white border border-black/5 rounded-2xl px-5 py-4 shadow-xl">
              <div className="text-[10px] uppercase tracking-[0.22em] text-forest-soft">Maryland's top rated</div>
              <div className="font-heading text-xl mt-1 flex items-center gap-2">
                <Star size={16} className="text-clay fill-clay" /> 4.9 average rating
              </div>
              <div className="text-xs text-muted2 mt-1">Across 1,247 verified reviews</div>
            </div>
          </div>
          <div className="absolute -top-6 -right-4 bg-forest text-bone rounded-2xl px-4 py-3 hidden md:block">
            <div className="text-[10px] uppercase tracking-[0.22em] text-bone/70">Next available</div>
            <div className="font-heading text-base">Tomorrow · 10:00 AM</div>
          </div>
        </div>
      </div>
    </section>
  );
}
